import React, { useEffect, useState } from "react";

import IPrice_BandUI from "../../../../../../models/IPrice_BandUI";
import { OwFnInput } from "../../../../../shared/OwFnInput/OwFnInput";

type Props = {
    band: Partial<IPrice_BandUI>;
    index: number;
    removePriceBand: (index: number) => void;
    updateBand: (band: Partial<IPrice_BandUI>, index: number) => void;
};

export const PriceBandBuilderTableRow = (props: Props) => {
    const [band, setBand] = useState<Partial<IPrice_BandUI>>(props.band);

    const handleChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;

        const newBand = {
            ...band,
            [name]: value,
        };

        setBand(newBand);

        props.updateBand(newBand, props.index);
    };

    return (
        <tr>
            <td>
                <i className={"fas fa-trash-alt text-danger pointer me-4"} onClick={() => props.removePriceBand(props.index)}></i>
            </td>
            <td>
                <OwFnInput fn={handleChange} name={"start_qty"} value={band.start_qty} />
            </td>
            <td>
                <OwFnInput fn={handleChange} name={"end_qty"} value={band.end_qty} />
            </td>
            <td>
                <OwFnInput fn={handleChange} name={"price"} value={band.price} />
            </td>
        </tr>
    );
};
